module.exports = "<aside class=\"aside-menu\">\r\n</aside>\r\n"


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/core/components/layout/sidebar-left/sidebar-left.component.html
// module id = ../../../../../src/app/core/components/layout/sidebar-left/sidebar-left.component.html
// module chunks = main